import React, { createContext, useContext, useState, useEffect } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [showAdModal, setShowAdModal] = useState(false);
  const [showChatBubble, setShowChatBubble] = useState(false);
  const [searchMode, setSearchMode] = useState(null); // 'browse' or 'create-request'
  const [filters, setFilters] = useState({
    city: "",
    rooms: "",
    minArea: "",
    maxArea: "",
    minPrice: "",
    maxPrice: "",
    furnishing: "",
    minConstructionYear: "",
    maxConstructionYear: "",
    advertise_type: "Mieten",
    category: "",
    name: "",
    mail: "",
    notes: "",
  });

  const handleShowAdModal = () => setShowAdModal((prevState) => !prevState);
  
  const handleShowChatBubble = () => {
    setShowChatBubble(true);
    // Sofort wieder auf false setzen, damit es beim nächsten Klick wieder funktioniert
    setTimeout(() => setShowChatBubble(false), 100);
  };
  
  return (
    <AppContext.Provider
      value={{
        showAdModal,
        handleShowAdModal,
        showChatBubble,
        handleShowChatBubble,
        filters,
        setFilters,
        searchMode,
        setSearchMode,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  return useContext(AppContext);
};
